export default {
  root: {
    fontSize: '0.875rem',
    lineHeight: 1.43,
  },
}
